import { __assign } from "tslib";
import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
import ExcerptRenderer from './ExcerptRenderer';
import BaseViewer from '../DaEditorWrapper/Viewer/Base';
import ErrorBoundary from '../ErrorBoundary';
var TextRenderer = function (_a) {
    var textContent = _a.textContent, className = _a.className, _b = _a.fallbackToExcerpt, fallbackToExcerpt = _b === void 0 ? true : _b, reactViewer = _a.reactViewer, htmlExcerptLegacy = _a.htmlExcerptLegacy, isPollWithHtmlExcerpt = _a.isPollWithHtmlExcerpt, width = _a.width, legacyTheme = _a.legacyTheme, excerptOnly = _a.excerptOnly, viewerKey = _a.viewerKey, disableStylesForLegacy = _a.disableStylesForLegacy, _c = _a.emptyPlaceHolder, emptyPlaceHolder = _c === void 0 ? '' : _c, fixedParagraph = _a.fixedParagraph, draftjsThemeOverride = _a.draftjsThemeOverride;
    if (!textContent) {
        return null;
    }
    var type = get(textContent, 'html.type');
    var markup = get(textContent, 'html.markup');
    if (!markup || excerptOnly) {
        if (!fallbackToExcerpt) {
            return null;
        }
        return (React.createElement(ExcerptRenderer, { textContent: textContent, className: className, emptyPlaceHolder: emptyPlaceHolder, legacyTheme: legacyTheme, htmlExcerptLegacy: htmlExcerptLegacy, isPollWithHtmlExcerpt: isPollWithHtmlExcerpt, disableStylesForLegacy: disableStylesForLegacy }));
    }
    switch (type) {
        case 'writer':
            return (React.createElement(WrapWidth, { width: width },
                React.createElement(LegacyTextRenderer, { className: className, html: markup, theme: legacyTheme, disableStyles: disableStylesForLegacy })));
        case 'draft':
            var Viewer = reactViewer || BaseViewer;
            // do not add theme when not asked for
            var viewerTheme = draftjsThemeOverride
                ? { theme: draftjsThemeOverride }
                : {};
            try {
                return (React.createElement(ErrorBoundary, null,
                    React.createElement(WrapWidth, { width: width },
                        React.createElement("div", { className: className },
                            React.createElement(Viewer, __assign({ key: viewerKey, content: JSON.parse(markup), fixedParagraph: fixedParagraph }, viewerTheme))))));
            }
            catch (e) {
                return null;
            }
        default:
            return null;
    }
};
TextRenderer.displayName = 'TextRenderer';
var WrapWidth = function (_a) {
    var width = _a.width, children = _a.children;
    if (!width) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement("div", { style: { width: width } }, children);
};
WrapWidth.displayName = 'WrapWidth';
export default TextRenderer;
//# sourceMappingURL=TextRenderer.js.map